import gql from 'graphql-tag';
import {fragments as mapHitFragments} from '../MapHit/MapHit';

const mapFragments = {
    searchResult: gql`
        fragment MapSearchResult on SearchResult {
            mapViewport {
                neLat
                neLong
                swLat
                swLong
            }
            page
            pageSize
            listings {
                ...MapHitListing
            }
            pinnedListing {
                listing {
                    ...MapHitListing
                }
            }
        }
        ${mapHitFragments.listing}
    `
};

export {mapFragments};
